import { Component } from '../DocTypes';
import { iconAndTextStory } from '../TagList/Stories/iconAndTextStory';
import { leftAndRightItemsStory } from '../TagList/Stories/leftAndRightItemsStory';
import { inlineTextStory } from '../TagList/Stories/inlineTextStory';
import { dataFormattingStory } from '../TagList/Stories/dataFormattingStory';
import { dataDrivenItemStylesStory } from '../TagList/Stories/dataDrivenItemStylesStory';
import { imageStory } from '../TagList/Stories/imageStory';
import { avatarStory } from '../TagList/Stories/avatarStory';
import { clientPagingStory } from '../TagList/Stories/clientPagingStory';
import { clientPagingWithSlotStory } from '../TagList/Stories/clientPagingWithSlotStory';
import { clientPagingWithFilterStory } from '../TagList/Stories/clientPagingWithFilterStory';
import { dataDrivenIconStory } from '../TagList/Stories/dataDrivenIconStory';
import { buttonsStory } from '../TagList/Stories/buttonsStory';
import { roundedButtonsStory } from '../TagList/Stories/roundedButtonsStory';
import { squaredButtonsStory } from '../TagList/Stories/squaredButtonsStory';
import { dataDrivenEnabledButtonStory } from '../TagList/Stories/dataDrivenEnabledButtonStory';
import { dataDrivenButtonAccentStory } from '../TagList/Stories/dataDrivenButtonAccentStory';
import { dataDrivenButtonStylesStory } from '../TagList/Stories/dataDrivenButtonStylesStory';
import { buttonAfterTextStory } from '../TagList/Stories/buttonAfterTextStory';
import { buttonClickWithDataStory } from '../TagList/Stories/buttonClickWithDataStory';
import { selectableStory } from '../TagList/Stories/selectableStory';
import { selectableWithDefaultStory } from '../TagList/Stories/selectableWithDefaultStory';
import { DeselectStory } from '../TagList/Stories/DeselectStory';
import { multiCheckStory } from '../TagList/Stories/multiCheckStory';
import { multiCheckWithDefaultsStory } from '../TagList/Stories/multiCheckWithDefaultsStory';
import { dataDrivenDisabledMultiCheckStory } from '../TagList/Stories/dataDrivenDisabledMultiCheckStory';
import { dataDrivenPillsStory } from '../TagList/Stories/dataDrivenPillsStory';
import { templateStory } from '../TagList/Stories/templateStory';
import { horizontalTemplateStory } from '../TagList/Stories/horizontalTemplateStory';
import { templateButtonWithPopover } from '../TagList/Stories/templateButtonWithPopover';
import { DeselectWithRenderItemStory } from './Stories/DeselectWithRenderItemStory';
import { listItemClickedStory } from './Stories/listItemClick';

export const TagListDocs: Component = {
  type: 'component',
  name: 'list',
  description: 'Renders a list',
  mobileFriendly: true,
  preRelease: '',
  popular: true,
  props: [
    {
      name: 'multiCheck',
      description: 'Whether multiple items can be selected',
      type: 'boolean',
    },
    {
      name: 'multiCheckAlign',
      description: 'Whether the checkbox is on the left or right',
      type: 'left | right',
      default: 'left',
    },
    {
      name: 'multiCheckSize',
      description: 'The size of the checkbox',
      type: 'normal | large',
      default: 'normal',
    },
    {
      name: 'multiCheckRounded',
      description: 'Whether the checkbox is rounded',
      type: 'boolean',
    },
    {
      name: 'multiCheckAccent',
      description: 'The accent of the checkbox',
      type: 'boolean',
    },
    {
      name: 'multiCheckSuppressSelectAll',
      description: 'Whether the select all checkbox is suppressed',
      type: 'boolean',
      default: 'false',
    },
    {
      name: 'multiCheckSelectAllPosition',
      description: 'The position of the SelectAll checkbox',
      type: 'bottom | top',
      default: 'bottom',
    },
    {
      name: 'multiCheckSelectAllLabel',
      description: 'The label of the SelectAll checkbox',
      type: 'string',
      default: 'Select All',
    },
    {
      name: 'selectable',
      description:
        'Whether items in the list can be selected and allow the listItemSelected event to be raised',
      type: 'boolean',
    },
    {
      name: 'data',
      description:
        'The data that drives the list. The primaryField, secondaryField, imageField, leftIconField and rightIconField properties should reference properties in each object in this array',
      type: 'any[]',
    },
    {
      name: 'page',
      description: 'The current page number',
      type: 'number',
    },
    {
      name: 'pageSize',
      description: 'The page size',
      type: 'number',
    },
    {
      name: 'pageCount',
      description: 'The total number of pages',
      type: 'number',
    },
    {
      name: 'pagerAccent',
      description: 'The color of pager',
      type: 'Accent',
    },
    {
      name: 'pagerShowFirstLast',
      description: 'Whether the "go to first" and "go to last" pager buttons are visible',
      type: 'boolean',
    },
    {
      name: 'recordCount',
      description: 'The total number of records',
      type: 'number',
    },
    {
      name: 'imageField',
      description: 'The property name in the data item that gives an image path',
      type: 'string',
    },
    {
      name: 'imageWidth',
      description: 'The width of the image',
      type: 'string',
    },
    {
      name: 'imageHeight',
      description: 'The height of the image',
      type: 'string',
    },
    {
      name: 'imageBorderRadius',
      description: 'The border radius of the image',
      type: 'string',
    },
    {
      name: 'imageObjectFit',
      description: 'How the images fits the height and width',
      type:
        'contain | cover | fill | none | scale-down. See https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit for more information',
    },
    {
      name: 'avatarSrcField',
      description: 'The field in the data array prop that gives an avatar source ',
      type: 'string',
    },
    {
      name: 'avatarPlaceholderField',
      description: 'The field in the data array prop that gives an avatar placeholder',
      type: 'string',
    },
    {
      name: 'avatarSize',
      description: 'The size of the avatar',
      type: 'string',
    },
    {
      name: 'leftIcon',
      description: 'The left icon name',
      type: 'string',
    },
    {
      name: 'leftIconRoundedBackground',
      description: 'Left rounded background',
      type: 'boolean',
    },
    {
      name: 'leftIconField',
      description: 'The property name in the data item that gives an left icon name',
      type: 'string',
    },
    {
      name: 'leftIconAccentField',
      description: 'The property name in the data item that gives the left icon color',
      type: 'string',
    },
    {
      name: 'leftIconTitleField',
      description: 'The property name in the data item that sets the left icon tooltip',
      type: 'string',
    },
    {
      name: 'leftIconSize',
      description: 'The left icon size',
      type: 'number',
    },
    {
      name: 'leftIconAccent',
      description: 'The left icon color',
      type: 'string',
    },
    {
      name: 'leftIconStyle',
      description: 'The left icon style',
      type: 'string',
    },
    {
      name: 'rightIcon',
      description: 'The right icon name',
      type: 'string',
    },
    {
      name: 'rightIconRoundedBackground',
      description: 'Right rounded background',
      type: 'boolean',
    },
    {
      name: 'rightIconField',
      description: 'The property name in the data item that gives an right icon name',
      type: 'string',
    },
    {
      name: 'rightIconSize',
      description: 'The right icon size',
      type: 'number',
    },
    {
      name: 'rightIconAccent',
      description: 'The right icon color',
      type: 'string',
    },
    {
      name: 'rightIconStyle',
      description: 'The right icon style',
      type: 'string',
    },
    {
      name: 'rightIconAccentField',
      description: 'The property name in the data item that gives the right icon color',
      type: 'string',
    },
    {
      name: 'rightIconTitleField',
      description: 'The property name in the data item that sets the right icon tooltip',
      type: 'string',
    },
    {
      name: 'primaryField',
      description: 'The property name in the data item that gives the primary bit of information',
      type: 'string',
    },
    {
      name: 'primaryFieldInline',
      description: 'Whether the primary field should be inline',
      type: 'boolean',
    },
    {
      name: 'secondaryField',
      description: 'The property name in the data item that gives the secondary bit of information',
      type: 'string',
    },
    {
      name: 'secondaryFieldIcon',
      description: 'An icon to appear next to the secondary field',
      type: 'string',
    },
    {
      name: 'secondaryFieldIconAccent',
      description: 'The accent for the secondary icon',
      type: 'string',
    },
    {
      name: 'secondaryIconField',
      description: 'The property name in the data item that gives an left icon name',
      type: 'string',
    },
    {
      name: 'secondaryIconAccentField',
      description: 'The property name in the data item that gives the left icon color',
      type: 'string',
    },
    {
      name: 'secondaryFieldInline',
      description: 'Whether the secondary field should be inline',
      type: 'boolean',
    },
    {
      name: 'leftLabel1',
      description: 'The label for leftField1',
      type: 'string',
    },
    {
      name: 'leftField1',
      description:
        'The property name in the data item that gives the value under the secondary value',
      type: 'string',
    },
    {
      name: 'leftField1Icon',
      description: 'An icon to appear next to left field 1',
      type: 'string',
    },
    {
      name: 'leftField1IconAccent',
      description: 'The accent for the left field 1 icon',
      type: 'string',
    },
    {
      name: 'leftField1IconField',
      description: 'The property name in the data item that gives an left icon name',
      type: 'string',
    },
    {
      name: 'leftField1IconAccentField',
      description: 'The property name in the data item that gives the left icon color',
      type: 'string',
    },
    {
      name: 'leftField1Inline',
      description: 'Whether left field 1 should be inline',
      type: 'boolean',
    },
    {
      name: 'leftLabel2',
      description: 'The label for leftField2',
      type: 'string',
    },
    {
      name: 'leftField2',
      description: 'The field under leftField1',
      type: 'string',
    },
    {
      name: 'leftField2Icon',
      description: 'An icon to appear next to left field 2',
      type: 'string',
    },
    {
      name: 'leftField2IconAccent',
      description: 'The accent for the left field 2 icon',
      type: 'string',
    },
    {
      name: 'leftField2IconField',
      description: 'The property name in the data item that gives an left icon name',
      type: 'string',
    },
    {
      name: 'leftField2IconAccentField',
      description: 'The property name in the data item that gives the left icon color',
      type: 'string',
    },
    {
      name: 'leftField2Inline',
      description: 'Whether left field 2 should be inline',
      type: 'boolean',
    },
    {
      name: 'leftLabel3',
      description: 'The label for leftField3',
      type: 'string',
    },
    {
      name: 'leftField3',
      description: 'The field under leftField2',
      type: 'string',
    },
    {
      name: 'leftField3Icon',
      description: 'An icon to appear next to left field 3',
      type: 'string',
    },
    {
      name: 'leftField3IconAccent',
      description: 'The accent for the left field 3 icon',
      type: 'string',
    },
    {
      name: 'leftField3IconField',
      description: 'The property name in the data item that gives an left icon name',
      type: 'string',
    },
    {
      name: 'leftField3IconAccentField',
      description: 'The property name in the data item that gives the left icon color',
      type: 'string',
    },
    {
      name: 'leftField3Inline',
      description: 'Whether left field 3 should be inline',
      type: 'boolean',
    },
    {
      name: 'leftLabel4',
      description: 'The label for leftField4',
      type: 'string',
    },
    {
      name: 'leftField4',
      description: 'The field under leftField3',
      type: 'string',
    },
    {
      name: 'leftField4Icon',
      description: 'An icon to appear next to left field 4',
      type: 'string',
    },
    {
      name: 'leftField4IconAccent',
      description: 'The accent for the left field 4 icon',
      type: 'string',
    },
    {
      name: 'leftField4IconField',
      description: 'The property name in the data item that gives an left icon name',
      type: 'string',
    },
    {
      name: 'leftField4IconAccentField',
      description: 'The property name in the data item that gives the left icon color',
      type: 'string',
    },
    {
      name: 'leftField4Inline',
      description: 'Whether left field 4 should be inline',
      type: 'boolean',
    },
    {
      name: 'leftLabel5',
      description: 'The label for leftField5',
      type: 'string',
    },
    {
      name: 'leftField5',
      description: 'The field under leftField4',
      type: 'string',
    },
    {
      name: 'leftField5Icon',
      description: 'An icon to appear next to left field 5',
      type: 'string',
    },
    {
      name: 'leftField5IconAccent',
      description: 'The accent for the left field 5 icon',
      type: 'string',
    },
    {
      name: 'leftField5IconField',
      description: 'The property name in the data item that gives an left icon name',
      type: 'string',
    },
    {
      name: 'leftField5IconAccentField',
      description: 'The property name in the data item that gives the left icon color',
      type: 'string',
    },
    {
      name: 'leftField5Inline',
      description: 'Whether left field 5 should be inline',
      type: 'boolean',
    },
    {
      name: 'rightLabel1',
      description: 'The label for rightField1',
      type: 'string',
    },
    {
      name: 'rightField1',
      description: 'The field in the data item that appears at the right of the list',
      type: 'string',
    },
    {
      name: 'rightLabel2',
      description: 'The label for rightField2',
      type: 'string',
    },
    {
      name: 'rightField2',
      description: 'The field under rightField1 ',
      type: 'string',
    },
    {
      name: 'rightLabel3',
      description: 'The label for rightField3',
      type: 'string',
    },
    {
      name: 'rightField3',
      description: 'The field under rightField2',
      type: 'string',
    },
    {
      name: 'rightLabel4',
      description: 'The label for rightField4',
      type: 'string',
    },
    {
      name: 'rightField4',
      description: 'The field under rightField3',
      type: 'string',
    },
    {
      name: 'rightLabel5',
      description: 'The label for rightField5',
      type: 'string',
    },
    {
      name: 'rightField5',
      description: 'The field under rightField4',
      type: 'string',
    },
    {
      name: 'primaryFieldType',
      description: 'The primary field data type',
      type: `'integer'| 'decimal' | 'currency' | 'date' | 'datetime' | 'boolean' | 'image' | 'email' | 'phonenumber'`,
    },
    {
      name: 'secondaryFieldType',
      description: 'The secondary field data type',
      type: `'integer'| 'decimal' | 'currency' | 'date' | 'datetime' | 'boolean' | 'image' | 'email' | 'phonenumber'`,
    },
    {
      name: 'leftField1Type',
      description: 'The leftField1 data type',
      type: `'integer'| 'decimal' | 'currency' | 'date' | 'datetime' | 'boolean' | 'image' | 'email' | 'phonenumber'`,
    },
    {
      name: 'leftField2Type',
      description: 'The leftField2 data type',
      type: `'integer'| 'decimal' | 'currency' | 'date' | 'datetime' | 'boolean' | 'image' | 'email' | 'phonenumber'`,
    },
    {
      name: 'leftField3Type',
      description: 'The leftField3 data type',
      type: `'integer'| 'decimal' | 'currency' | 'date' | 'datetime' | 'boolean' | 'image' | 'email' | 'phonenumber'`,
    },
    {
      name: 'leftField4Type',
      description: 'The leftField4 data type',
      type: `'integer'| 'decimal' | 'currency' | 'date' | 'datetime' | 'boolean' | 'image' | 'email' | 'phonenumber'`,
    },
    {
      name: 'leftField5Type',
      description: 'The leftField5 data type',
      type: `'integer'| 'decimal' | 'currency' | 'date' | 'datetime' | 'boolean' | 'image' | 'email' | 'phonenumber'`,
    },
    {
      name: 'rightField1Type',
      description: 'The rightField1 data type',
      type: `'integer'| 'decimal' | 'currency' | 'date' | 'datetime' | 'boolean' | 'image' | 'email' | 'phonenumber'`,
    },
    {
      name: 'rightField2Type',
      description: 'The rightField2 data type',
      type: `'integer'| 'decimal' | 'currency' | 'date' | 'datetime' | 'boolean' | 'image' | 'email' | 'phonenumber'`,
    },
    {
      name: 'rightField3Type',
      description: 'The rightField3 data type',
      type: `'integer'| 'decimal' | 'currency' | 'date' | 'datetime' | 'boolean' | 'image' | 'email' | 'phonenumber'`,
    },
    {
      name: 'rightField4Type',
      description: 'The rightField4 data type',
      type: `'integer'| 'decimal' | 'currency' | 'date' | 'datetime' | 'boolean' | 'image' | 'email' | 'phonenumber'`,
    },
    {
      name: 'rightField5Type',
      description: 'The rightField5 data type',
      type: `'integer'| 'decimal' | 'currency' | 'date' | 'datetime' | 'boolean' | 'image' | 'email' | 'phonenumber'`,
    },

    {
      name: 'rightField1Icon',
      description: 'An icon to appear next to right field 1',
      type: 'string',
    },
    {
      name: 'rightField1IconAccent',
      description: 'The accent for the right field 1 icon',
      type: 'string',
    },
    {
      name: 'rightField1IconField',
      description: 'The property name in the data item that gives an left icon name',
      type: 'string',
    },
    {
      name: 'rightField1IconAccentField',
      description: 'The property name in the data item that gives the left icon color',
      type: 'string',
    },
    {
      name: 'rightField1Inline',
      description: 'Whether right field 1 should be inline',
      type: 'boolean',
    },
    {
      name: 'rightField2Icon',
      description: 'An icon to appear next to right field 2',
      type: 'string',
    },
    {
      name: 'rightField2IconAccent',
      description: 'The accent for the right field 2 icon',
      type: 'string',
    },
    {
      name: 'rightField2IconField',
      description: 'The property name in the data item that gives an left icon name',
      type: 'string',
    },
    {
      name: 'rightField2IconAccentField',
      description: 'The property name in the data item that gives the left icon color',
      type: 'string',
    },
    {
      name: 'rightField2Inline',
      description: 'Whether right field 2 should be inline',
      type: 'boolean',
    },
    {
      name: 'rightField3Icon',
      description: 'An icon to appear next to right field 3',
      type: 'string',
    },
    {
      name: 'rightField3IconAccent',
      description: 'The accent for the right field 3 icon',
      type: 'string',
    },
    {
      name: 'rightField3IconField',
      description: 'The property name in the data item that gives an left icon name',
      type: 'string',
    },
    {
      name: 'rightField3IconAccentField',
      description: 'The property name in the data item that gives the left icon color',
      type: 'string',
    },
    {
      name: 'rightField3Inline',
      description: 'Whether right field 3 should be inline',
      type: 'boolean',
    },
    {
      name: 'rightField4Icon',
      description: 'An icon to appear next to right field 4',
      type: 'string',
    },
    {
      name: 'rightField4IconAccent',
      description: 'The accent for the right field 4 icon',
      type: 'string',
    },
    {
      name: 'rightField4IconField',
      description: 'The property name in the data item that gives an left icon name',
      type: 'string',
    },
    {
      name: 'rightField4IconAccentField',
      description: 'The property name in the data item that gives the left icon color',
      type: 'string',
    },
    {
      name: 'rightField4Inline',
      description: 'Whether right field 4 should be inline',
      type: 'boolean',
    },

    {
      name: 'rightField5Icon',
      description: 'An icon to appear next to right field 5',
      type: 'string',
    },
    {
      name: 'rightField5IconAccent',
      description: 'The accent for the right field 5 icon',
      type: 'string',
    },
    {
      name: 'rightField5IconField',
      description: 'The property name in the data item that gives an left icon name',
      type: 'string',
    },
    {
      name: 'rightField5IconAccentField',
      description: 'The property name in the data item that gives the left icon color',
      type: 'string',
    },
    {
      name: 'rightField5Inline',
      description: 'Whether right field 5 should be inline',
      type: 'boolean',
    },

    {
      name: 'primaryFieldStyle',
      description: 'JSX style object in JSON to apply to the primary field',
      type: 'string',
    },
    {
      name: 'secondaryFieldStyle',
      description: 'JSX style object in JSON to apply to the secondary field',
      type: 'string',
    },
    {
      name: 'leftLabel1Style',
      description: 'JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'leftLabel2Style',
      description: 'JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'leftLabel3Style',
      description: 'JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'leftLabel4Style',
      description: 'JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'leftLabel5Style',
      description: 'JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'rightLabel1Style',
      description: 'JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'rightLabel2Style',
      description: 'JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'rightLabel3Style',
      description: 'JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'rightLabel4Style',
      description: 'JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'rightLabel5Style',
      description: 'JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'leftField1Style',
      description: 'JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'leftField2Style',
      description: 'JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'leftField3Style',
      description: 'JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'leftField4Style',
      description: 'JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'leftField5Style',
      description: 'JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'rightField1Style',
      description: 'JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'rightField2Style',
      description: 'JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'rightField3Style',
      description: 'JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'rightField4Style',
      description: 'JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'rightField5Style',
      description: 'JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'primaryFieldStyleField',
      description: 'Field that gives JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'secondaryFieldStyleField',
      description: 'Field that gives JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'leftField1StyleField',
      description: 'Field that gives JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'leftField2StyleField',
      description: 'Field that gives JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'leftField3StyleField',
      description: 'Field that gives JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'leftField4StyleField',
      description: 'Field that gives JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'leftField5StyleField',
      description: 'Field that gives JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'rightField1StyleField',
      description: 'Field that gives JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'rightField2StyleField',
      description: 'Field that gives JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'rightField3StyleField',
      description: 'Field that gives JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'rightField4StyleField',
      description: 'Field that gives JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'rightField5StyleField',
      description: 'Field that gives JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'button1',
      description: 'The text for a button to do an operation on the list item',
      type: 'string',
    },
    {
      name: 'button1Icon',
      description: 'The icon for the button',
      type: 'string',
    },
    {
      name: 'button1Accent',
      description: 'The colour of the button',
      type: 'string',
    },
    {
      name: 'button1Rounded',
      description: 'Whether the button is rounded',
      type: 'boolean',
    },
    {
      name: 'button1Squared',
      description: 'Whether the button is squared',
      type: 'boolean',
    },
    {
      name: 'button1Disabled',
      description: 'Whether the button is disabled',
      type: 'boolean',
    },
    {
      name: 'button1DisabledField',
      description: 'The field in the data source that determines whether button is disabled',
      type: 'string',
    },
    {
      name: 'button1Style',
      description: 'The JSX style object in JSON to apply to the button',
      type: 'string',
    },
    {
      name: 'button1StyleField',
      description: 'The field that contains the JSX style object in JSON to apply to the button',
      type: 'string',
    },
    {
      name: 'button1HostStyle',
      description: 'The JSX style object in JSON to apply to the button host element',
      type: 'string',
    },
    {
      name: 'button2',
      description: 'The text for a 2nd button to do an operation on the list item',
      type: 'string',
    },
    {
      name: 'button2Icon',
      description: 'The icon for the 2nd button',
      type: 'string',
    },
    {
      name: 'button2Accent',
      description: 'The colour of the 2nd button',
      type: 'string',
    },
    {
      name: 'button2Rounded',
      description: 'Whether the button is rounded',
      type: 'boolean',
    },
    {
      name: 'button2Squared',
      description: 'Whether the button is squared',
      type: 'boolean',
    },
    {
      name: 'button2Disabled',
      description: 'Whether the button is disabled',
      type: 'boolean',
    },
    {
      name: 'button2DisabledField',
      description: 'The field in the data source that determines whether button is disabled',
      type: 'string',
    },
    {
      name: 'button2Style',
      description: 'The JSX style object in JSON to apply to the button',
      type: 'string',
    },
    {
      name: 'button2StyleField',
      description: 'The field that contains the JSX style object in JSON to apply to the button',
      type: 'string',
    },
    {
      name: 'button2HostStyle',
      description: 'The JSX style object in JSON to apply to the button host element',
      type: 'string',
    },
    {
      name: 'button3',
      description: 'The text for a 3rd button to do an operation on the list item',
      type: 'string',
    },
    {
      name: 'button3Icon',
      description: 'The icon for the 3rd button',
      type: 'string',
    },
    {
      name: 'button3Accent',
      description: 'The colour of the 3rd button',
      type: 'string',
    },
    {
      name: 'button3Rounded',
      description: 'Whether the button is rounded',
      type: 'boolean',
    },
    {
      name: 'button3Squared',
      description: 'Whether the button is squared',
      type: 'boolean',
    },
    {
      name: 'button3Disabled',
      description: 'Whether the button is disabled',
      type: 'boolean',
    },
    {
      name: 'button3DisabledField',
      description: 'The field in the data source that determines whether button is disabled',
      type: 'string',
    },
    {
      name: 'button3Style',
      description: 'The JSX style object in JSON to apply to the button',
      type: 'string',
    },
    {
      name: 'button3StyleField',
      description: 'The field that contains the JSX style object in JSON to apply to the button',
      type: 'string',
    },
    {
      name: 'button3HostStyle',
      description: 'The JSX style object in JSON to apply to the button host element',
      type: 'string',
    },
    {
      name: 'button4',
      description: 'The text for a 4th button to do an operation on the list item',
      type: 'string',
    },
    {
      name: 'button4Icon',
      description: 'The icon for the 4th button',
      type: 'string',
    },
    {
      name: 'button4Accent',
      description: 'The colour of the 4th button',
      type: 'string',
    },
    {
      name: 'button4Rounded',
      description: 'Whether the button is rounded',
      type: 'boolean',
    },
    {
      name: 'button4Squared',
      description: 'Whether the button is squared',
      type: 'boolean',
    },
    {
      name: 'button4Disabled',
      description: 'Whether the button is disabled',
      type: 'boolean',
    },
    {
      name: 'button4DisabledField',
      description: 'The field in the data source that determines whether button is disabled',
      type: 'string',
    },
    {
      name: 'button4Style',
      description: 'The JSX style object in JSON to apply to the button',
      type: 'string',
    },
    {
      name: 'button4StyleField',
      description: 'The field that contains the JSX style object in JSON to apply to the button',
      type: 'string',
    },
    {
      name: 'button4HostStyle',
      description: 'The JSX style object in JSON to apply to the button host element',
      type: 'string',
    },
    {
      name: 'button5',
      description: 'The text for a 5th button to do an operation on the list item',
      type: 'string',
    },
    {
      name: 'button5Icon',
      description: 'The icon for the 5th button',
      type: 'string',
    },
    {
      name: 'button5Accent',
      description: 'The colour of the 5th button',
      type: 'string',
    },
    {
      name: 'button5Rounded',
      description: 'Whether the button is rounded',
      type: 'boolean',
    },
    {
      name: 'button5Squared',
      description: 'Whether the button is squared',
      type: 'boolean',
    },
    {
      name: 'button5Disabled',
      description: 'Whether the button is disabled',
      type: 'boolean',
    },
    {
      name: 'button5DisabledField',
      description: 'The field in the data source that determines whether button is disabled',
      type: 'string',
    },
    {
      name: 'button5Style',
      description: 'The JSX style object in JSON to apply to the button',
      type: 'string',
    },
    {
      name: 'button5StyleField',
      description: 'The field that contains the JSX style object in JSON to apply to the button',
      type: 'string',
    },
    {
      name: 'button5HostStyle',
      description: 'The JSX style object in JSON to apply to the button host element',
      type: 'string',
    },
    {
      name: 'minHeight',
      description: 'The min height of the list',
      type: 'string',
    },
    {
      name: 'height',
      description:
        'The height of the list. If this is set, a scrollbar will show when the items go beyond the height',
      type: 'string',
    },
    {
      name: 'containerStyle',
      description:
        'JSX style object in JSON to apply to the container for the list, pager and multi-select container',
      type: 'string',
    },
    {
      name: 'listContainerStyle',
      description: 'JSX style object in JSON to apply to the container for the list',
      type: 'string',
    },
    {
      name: 'itemContainerClassName',
      description: 'The class name for the item container',
      type:
        'tag-list-compact | tag-list-card | tag-list-compact no-outer-border | tag-list-compact middle-border-only',
    },
    {
      name: 'itemContainerClassNameField',
      description: 'The field to get the class name for the item container',
      type: 'string',
    },
    {
      name: 'itemContainerStyle',
      description: 'JSX style object in JSON to apply to the list item containers',
      type: 'string',
    },
    {
      name: 'itemContainerInnerLeftStyle',
      description: 'Style for the left side of the rows',
      type: 'string',
    },
    {
      name: 'itemContainerInnerRightStyle',
      description: 'Style for the right side of the rows',
      type: 'string',
    },
    {
      name: 'pillAlign',
      description: 'The alignment of the pills',
      type: ' left | right',
      default: 'left',
    },
    {
      name: 'pill1Field',
      description: 'The field under pill1Field',
      type: 'string',
    },
    {
      name: 'pill1FieldAccent',
      description: 'The default accent to use for pill1Field',
      type: 'string',
    },
    {
      name: 'pill1FieldAccentField',
      description: 'The field under pill1FieldAccentField that will override the pill 1 accent',
      type: 'string',
    },
    {
      name: 'pill1Style',
      description: 'The default style to use for pill1Field',
      type: 'string',
    },
    {
      name: 'pill1StyleField',
      description: 'field under pill1StyleField that will override the pill 1 style',
      type: 'string',
    },
    {
      name: 'pill1FieldType',
      description: 'the pill 1 field type',
      type: 'string',
    },
    {
      name: 'pill2Field',
      description: 'The field under pill2Field',
      type: 'string',
    },
    {
      name: 'pill2FieldAccent',
      description: 'The default accent to use for pill2Field',
      type: 'string',
    },
    {
      name: 'pill2FieldAccentField',
      description: 'The field under pill2FieldAccentField that will override the pill 2 accent',
      type: 'string',
    },
    {
      name: 'pill2Style',
      description: 'The default style to use for pill2Field',
      type: 'string',
    },
    {
      name: 'pill2StyleField',
      description: 'field under pill2StyleField that will override the pill 2 style',
      type: 'string',
    },
    {
      name: 'pill2FieldType',
      description: 'the pill 2 field type',
      type: 'string',
    },
    {
      name: 'pill3Field',
      description: 'The field under pill3Field',
      type: 'string',
    },
    {
      name: 'pill3FieldAccent',
      description: 'The default accent to use for pill3Field',
      type: 'string',
    },
    {
      name: 'pill3FieldAccentField',
      description: 'The field under pill3FieldAccentField that will override the pill 3 accent',
      type: 'string',
    },
    {
      name: 'pill3Style',
      description: 'The default style to use for pill3Field',
      type: 'string',
    },
    {
      name: 'pill3StyleField',
      description: 'field under pill3StyleField that will override the pill 3 style',
      type: 'string',
    },
    {
      name: 'pill3FieldType',
      description: 'the pill 3 field type',
      type: 'string',
    },
    {
      name: 'pill4Field',
      description: 'The field under pill4Field',
      type: 'string',
    },
    {
      name: 'pill4FieldAccent',
      description: 'The default accent to use for pill4Field',
      type: 'string',
    },
    {
      name: 'pill4FieldAccentField',
      description: 'The field under pill4FieldAccentField that will override the pill 4 accent',
      type: 'string',
    },
    {
      name: 'pill4Style',
      description: 'The default style to use for pill4Field',
      type: 'string',
    },
    {
      name: 'pill4StyleField',
      description: 'field under pill4StyleField that will override the pill 4 style',
      type: 'string',
    },
    {
      name: 'pill4FieldType',
      description: 'the pill 4 field type',
      type: 'string',
    },
    {
      name: 'pill5Field',
      description: 'The field under pill5Field',
      type: 'string',
    },
    {
      name: 'pill5FieldAccent',
      description: 'The default accent to use for pill5Field',
      type: 'string',
    },
    {
      name: 'pill5FieldAccentField',
      description: 'The field under pill5FieldAccentField that will override the pill 5 accent',
      type: 'string',
    },
    {
      name: 'pill5Style',
      description: 'The default style to use for pill5Field',
      type: 'string',
    },
    {
      name: 'pill5StyleField',
      description: 'field under pill5StyleField that will override the pill 5 style',
      type: 'string',
    },
    {
      name: 'pill5FieldType',
      description: 'the pill 5 field type',
      type: 'string',
    },
    {
      name: 'pagerAlign',
      description: 'The alignment of the pager',
      type: `'left' | 'right' | 'center'`,
      default: 'left',
    },
    {
      name: 'pagerContainerStyle',
      description: 'JSX style object in JSON to apply to the pager container for the list',
      type: 'string',
    },
    {
      name: 'multiCheckDisabledField',
      description: 'Allows to individually disable checkboxes in a data driven list',
      type: 'boolean',
    },
    {
      name: 'value',
      description: 'The value assigned to the button',
      type: 'string',
    },
    {
      name: 'actionName',
      description: 'The action assigned to the button',
      type: 'string',
    },
    // {
    //   name: 'colour-scheme',
    //   description:
    //     'V3 Only: Dark mode (theme) control. Default for normal browser driven control. Dark | Light to force respective styling regardless of browser setting.',
    //   type: 'dark | light | default',
    //   default: 'light',
    // },
    // {
    //   name: 'device',
    //   description: 'V3 Only: set preferred styling theme for device type.',
    //   type: 'desktop | mobile',
    //   default: 'desktop',
    // },
  ],
  reactPropOverrides: [],
  methods: [
    {
      name: 'setData',
      description: 'Sets the data and paging information for this component',
      parameters: [
        {
          name: 'data',
          description: 'The data to bind to the list',
          type: 'IPagedData | any[]',
        },
      ],
      returnType: 'void',
    },
    {
      name: 'select',
      description: 'Sets the selected item in the list if the list has the selectable attribute',
      parameters: [
        {
          name: 'item',
          description: 'The data item to select',
          type: 'any',
        },
      ],
      returnType: 'void',
    },
    {
      name: 'getCheckedItems',
      description: 'Gets the checked items in the list',
      parameters: [],
      returnType: 'any[]',
    },
    {
      name: 'setCheckedItems',
      description: 'Sets the checked items in the list',
      parameters: [
        {
          name: 'items',
          description: 'The array of data items to check',
          type: 'any[]',
        },
      ],
      returnType: 'void',
    },
  ],
  events: [
    {
      name: 'listItemSelected',
      description: 'Raised when a list item is selected',
      parameters: [
        {
          name: 'item',
          description: 'The data item behind the selected list item',
          type: 'any',
        },
        {
          name: 'itemIndex',
          description: 'The index of the list item selected',
          type: 'number',
        },
      ],
    },
    {
      name: 'listItemClicked',
      description: 'Raised when a list item is clicked',
      parameters: [
        {
          name: 'item',
          description: 'The data item behind the selected list item',
          type: 'any',
        },
        {
          name: 'itemIndex',
          description: 'The index of the list item selected',
          type: 'number',
        },
        {
          name: 'listItemElement',
          description: 'The list item Element',
          type: 'any',
        },
        {
          name: 'targetElement',
          description: 'The target element clicked',
          type: 'any',
        },
      ],
    },
    {
      name: 'listItemsChecked',
      description: 'Raised when list ltems are checked',
      parameters: [
        {
          name: 'changes',
          description: 'An array of items that have just been checked / unchecked',
          type: '{item: any, checked: boolean}[]',
        },
        {
          name: 'checkedItems',
          description: 'An array of currently checked list items. Returns [] when all unchecked.',
          type: 'any[]',
        },
        {
          name: 'items',
          description:
            'An array of items that have justed been checked. Deprecated because this does not handle unchecked items - use changes or checkedItems instead',
          type: 'any[]',
        },
      ],
    },
    {
      name: 'buttonClick',
      description: 'Raised when a button is clicked',
      parameters: [
        {
          name: 'item',
          description: 'The data item behind the list item where the button was clicked',
          type: 'any',
        },
        {
          name: 'itemIndex',
          description: 'The list item index where the button was clicked',
          type: 'number',
        },
        {
          name: 'buttonIndex',
          description: 'The button index that was clicked',
          type: 'number',
        },
      ],
    },
    {
      name: 'pageRequest',
      description: 'Event raised when a page button is clicked',
      parameters: [
        {
          name: 'page',
          description: 'The page number',
          type: 'number',
        },
      ],
    },
  ],
  stories: [
    iconAndTextStory,
    dataDrivenIconStory,
    leftAndRightItemsStory,
    inlineTextStory,
    dataFormattingStory,
    dataDrivenItemStylesStory,
    imageStory,
    avatarStory,
    clientPagingStory,
    clientPagingWithSlotStory,
    clientPagingWithFilterStory,
    buttonsStory,
    roundedButtonsStory,
    squaredButtonsStory,
    dataDrivenEnabledButtonStory,
    dataDrivenButtonAccentStory,
    dataDrivenButtonStylesStory,
    buttonAfterTextStory,
    buttonClickWithDataStory,
    selectableStory,
    listItemClickedStory,
    selectableWithDefaultStory,
    DeselectStory,
    DeselectWithRenderItemStory,
    multiCheckStory,
    multiCheckWithDefaultsStory,
    dataDrivenDisabledMultiCheckStory,
    dataDrivenPillsStory,
    templateStory,
    horizontalTemplateStory,
    templateButtonWithPopover,
  ],
};
